import { render, staticRenderFns } from "./GeniusBrain-yuhang.vue?vue&type=template&id=7d66691c&scoped=true&"
import script from "./GeniusBrain-yuhang.vue?vue&type=script&lang=js&"
export * from "./GeniusBrain-yuhang.vue?vue&type=script&lang=js&"
import style0 from "./GeniusBrain-yuhang.vue?vue&type=style&index=0&id=7d66691c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d66691c",
  null
  
)

export default component.exports